__webpack_require__.p = "/saas_mantra-react_task/";